module.exports = __webpack_public_path__ + "img/X.c35b8af7.svg";